import { render, staticRenderFns } from "./RequestSent.vue?vue&type=template&id=95e0d952&scoped=true&"
import script from "./RequestSent.vue?vue&type=script&lang=js&"
export * from "./RequestSent.vue?vue&type=script&lang=js&"
import style0 from "./RequestSent.vue?vue&type=style&index=0&id=95e0d952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e0d952",
  null
  
)

export default component.exports